import { render, staticRenderFns } from "./ProfileRegister.vue?vue&type=template&id=0691ab3d&"
import script from "./ProfileRegister.vue?vue&type=script&lang=js&"
export * from "./ProfileRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports